import React from 'react';
import Gear from '../../images/gear.svg'
import './styles.css';

export default function GearAnimation() {
    return (
        <div className="gears">
            <img src={Gear} alt="Gear" className="gear1"/>
            <img src={Gear} alt="Gear" className="gear2"/>
        </div>
    )
}